import {Viewer}                         from '../../components/Gallery/Viewer';
import React                            from 'react';
import {render, unmountComponentAtNode} from 'react-dom';
import PjaxWrapper                      from './../../utils/PjaxWrapper';
import {isImageUrl}                     from './../../utils/GalleryHelper';

const initImages = [];

/**
 * @param {string} viewerContainerId
 * @param {string} sourceContainerSelector
 */
function run(viewerContainerId, sourceContainerSelector) {
	let viewerContainer  = document.getElementById(viewerContainerId);
	const sourceContainers = document.querySelectorAll(sourceContainerSelector);

	// append to DOM if not existing
	if (!viewerContainer) {
		viewerContainer = document.createElement('div');
		viewerContainer.setAttribute('id', viewerContainerId);
		document.body.appendChild(viewerContainer);
	}

	// append empty if needed
	if (!initImages[viewerContainerId]) {
		initImages[viewerContainerId] = [];
	}

	// can be more then 1 on the page!
	for (let c = 0; c < sourceContainers.length; c++) {
		initImages[viewerContainerId][c] = [];

		const linkTags = sourceContainers[c].getElementsByClassName('js-gallery-viewer');

		// already filled - skip
		if (linkTags.length === initImages[viewerContainerId][c]) {
			return;
		}

		for (let i = 0; i < linkTags.length; i++) {
			const linkObjects = {},
			      href        = linkTags[i].href ? linkTags[i].href : '';

			if (isImageUrl(href.toLowerCase())) {
				linkObjects.origUrl = linkTags[i].href;
				linkTags[i].onclick = openViewer.bind(null, c, i, viewerContainer);
				initImages[viewerContainerId][c].push(linkObjects);
			}
		}
	}
}

/**
 * @param {Number} idx - album IDX
 * @param {Number} index - picture IDX
 * @param {Element} viewerContainer
 * @param {Event} event
 * @return {boolean}
 */
function openViewer(idx, index, viewerContainer, event) {
	event.preventDefault();

	const containerId = viewerContainer.getAttribute('id');

	render(
		<Viewer
			initialImages={initImages[containerId][idx]}
			selectedIndex={index}
			actor={null}
			initialIsFavoriteOfGuest={false}
			initShowModal={true}
			instanceId={"viewer-" + idx}
			isMobile={false}
			loader={null}
			onChange={null}
			onShowModal={null}
			showControlsNonModal={false}
			hideAlbumInfo={true}
			hideVoting={true}
		/>,
		viewerContainer
	);

	PjaxWrapper.addUnloadFunc(() => unmountComponentAtNode(viewerContainer));
}

export {run};
